var _rect, _rect2, _text, _text2, _rect3, _polyline, _text3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgP14(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 600,
    height: 340,
    viewBox: "0 0 600 340",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 340,
    fill: "#0d1b2a"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 560,
    height: 300,
    rx: 8,
    fill: "#112240",
    stroke: "#64ffda",
    strokeWidth: 1.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 100,
    fontFamily: "monospace",
    fontSize: 22,
    fill: "#64ffda",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "SpeechPal")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 135,
    fontFamily: "monospace",
    fontSize: 13,
    fill: "#8892b0",
    textAnchor: "middle"
  }, "Real-Time Speech Analysis Pipeline")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 155,
    width: 440,
    height: 2,
    fill: "#64ffda",
    opacity: 0.3
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "60,230 90,195 120,240 150,185 180,245 210,195 240,235 270,180 300,245 330,190 360,240 390,185 420,235 480,230 540,230",
    fill: "none",
    stroke: "#64ffda",
    strokeWidth: 2,
    opacity: 0.7
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 290,
    fontFamily: "monospace",
    fontSize: 12,
    fill: "#a8b2d8",
    textAnchor: "middle"
  }, "Python FastAPI \xB7 Whisper \xB7 NLP \xB7 GenAI")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgP14);
export default __webpack_public_path__ + "static/media/p14.d62d5124da4f64856dd319602ea47395.svg";
export { ForwardRef as ReactComponent };